module.exports = __webpack_public_path__ + "static/Banner-6-110ef97c808b5d00bff4305038436bf1.png";